import { FormCustomComponent } from '@typesApp/Forms'
import { AvailableChannelType, ProviderType } from '@typesApp/Insurer'
import {
  CustomOverviewComponent,
  InsurancePanelLinkComponent,
  InsurerLogosComponent,
  InsurerSelectComponent,
  ShoppingActionsComponent,
} from '../types/Overview.types'

export const isInsurerLogosComponent = (component: FormCustomComponent): component is InsurerLogosComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'insurer-logos'
    ? true
    : false
}

export const isInsurerSelectComponent = (component: FormCustomComponent): component is InsurerSelectComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'insurer-select'
    ? true
    : false
}

export const isInsurancePanelLinkComponent = (
  component: FormCustomComponent
): component is InsurancePanelLinkComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'insurance-panel-link'
    ? true
    : false
}

export const isShoppingActionsComponent = (component: FormCustomComponent): component is ShoppingActionsComponent => {
  return (component as CustomOverviewComponent).subtype === 'overview' &&
    (component as CustomOverviewComponent).variant === 'shopping-actions'
    ? true
    : false
}

/**
 * @returns a concatenated string from list of channels separated by |
 */
export const getChannelKey = (channels: AvailableChannelType[] = []): string => {
  return channels?.join('|') ?? ''
}

export const getProviderType = (channels: AvailableChannelType[] = []): ProviderType => {
  return channels?.includes(AvailableChannelType.ONLINE) ? ProviderType.IN_NETWORK : ProviderType.OUT_OF_NETWORK
}
